module.exports = __webpack_public_path__ + "img/banner5.f162cbaf.jpg";